"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class Token {
}
exports.Token = Token;
class SI {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.PARTIALLY;
        this.id = 'bifi.si';
        this.entryPointID = 'bifi';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [new MethodConfig_1.default('bifi.si', [], 'bifi')];
    }
    proccessCallResponse(responses, isValidAddress, network, currency) {
        const si = responses[0] || [];
        const address = si[0] || config_1.default.default.address.empty;
        const rawMarket = si[1] || [];
        const rawGlobal = si[2] || [];
        const rawReward = si[3] || '0';
        const assetList = [];
        const totalData = {
            total: new bifrost_number_1.default(rawGlobal[0] || '0').div(this.defaultDecimals).toStr(),
            daily: new bifrost_number_1.default(rawGlobal[1] || '0').div(this.defaultDecimals).toStr(),
            claimed: new bifrost_number_1.default(rawGlobal[2] || '0').div(this.defaultDecimals).toStr(),
            remaining: new bifrost_number_1.default(rawGlobal[3] || '0').div(this.defaultDecimals).toStr()
        };
        const userData = {
            earn: isValidAddress ? new bifrost_number_1.default(rawReward).div(this.defaultDecimals).toStr() : '0',
            address
        };
        for (const market of rawMarket) {
            const handlerID = parseInt(market[0] || 0);
            const price = new bifrost_number_1.default(market[1] || '0').div(this.defaultDecimals).toStr();
            const id = network.getHandlerTokenID(handlerID);
            const daily = new bifrost_number_1.default(market[2] || '0').div(this.defaultDecimals).toStr();
            const claimed = new bifrost_number_1.default(market[3] || '0').div(this.defaultDecimals).toStr();
            const deposit = new bifrost_number_1.default(market[4] || '0').div(this.defaultDecimals).toStr();
            const borrow = new bifrost_number_1.default(market[5] || '0').div(this.defaultDecimals).toStr();
            assetList.push({
                id,
                handlerID,
                price,
                daily,
                claimed,
                deposit,
                borrow
            });
            currency.setTokenPrice(id, new bifrost_number_1.default(price));
        }
        return {
            assetList,
            totalData,
            userData
        };
    }
}
exports.default = SI;
;
//# sourceMappingURL=SI.js.map